export const REQUEST_REASONS = `
  query requestReasons(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $filter: RequestReasonFilterInput
  ) {
    requestReasons(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      filter: $filter
    ) {
      __typename
      ... on RequestReason {
        id
        name
        translation_key
        manual
        contact_type
        parameters
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
